module.exports = __webpack_public_path__ + "img/data-processing.1d8986a6.svg";